// src/components/Footer.js
import fbicon from "../assets/facebook.svg";
import igicon from "../assets/instagram.svg";
import yticon from "../assets/youtube.svg";
import './CustomFooter.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="custom-footer">
            <div className='footer-content'>
                <p className="footer-text">
                    &copy; {currentYear} Akadeet. All Rights Reserved.
                </p>
                <div className='footer-socical-icons'>
                    <img src={yticon} alt='yticon' style={{ height: '24px', width: "24px", cursor: 'pointer' }} onClick={() => window.open('https://www.youtube.com/channel/UCGcLtVwybqROLi7IHc_a8Vw', '_blank')} />
                    <img src={igicon} alt='igicon' style={{ height: '24px', width: "24px", cursor: 'pointer' }} onClick={() => window.open('https://www.instagram.com/akadeet_entertainment', '_blank')} />
                    <img src={fbicon} alt='fbicon' style={{ height: '24px', width: "24px", cursor: 'pointer' }} onClick={() => window.open('https://www.facebook.com/akadeet.entertainment', '_blank')} />
                </div>
            </div>
        </footer>
    );
};

export default Footer;
